import { render, staticRenderFns } from "./private-charger.vue?vue&type=template&id=587a46bf"
import script from "./private-charger.vue?vue&type=script&lang=js"
export * from "./private-charger.vue?vue&type=script&lang=js"
import style0 from "./private-charger.vue?vue&type=style&index=0&id=587a46bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports